<template>
  <v-tooltip right :disabled="disabledTooltip">
    <template v-slot:activator="{ on }">
      <div v-on="on" v-if="showTeamsPicker">
        <div class="app-sidebar__link" @click="openTeamPicker">
          <div class="app-sidebar__link-icon">
            <icon-badge
              v-if="currentTeam"
              class="team-picker-button__badge"
              :icon="teamIcon"
              :color="currentTeam.color"
              :size="30"
            />
            <icon-base v-else icon="sidebar/teams" />
          </div>
          <div class="app-sidebar__link-text text-ellipsis">
            Team: {{ teamName }}
          </div>
        </div>
      </div>
    </template>
    <span>Team: {{ teamName }}</span>
  </v-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';
import EventBus from '@/factories/eventBus';
import { FEATURES } from '@/access/features';
import IconBadge from '@/components/basic/icon-badge/IconBadge';
import { teamBadgeIcon } from './teamIcon';

export default {
  name: 'TeamPickerButton',
  components: {
    IconBadge,
  },
  props: {
    disabledTooltip: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('users', ['isFeatureEnabled', 'isAdmin']),
    ...mapGetters('teams', ['currentTeam']),
    showTeamsPicker() {
      return this.isFeatureEnabled(FEATURES.TEAMS);
    },
    teamIcon() {
      return teamBadgeIcon(this.currentTeam);
    },
    teamName() {
      return this.currentTeam?.label || 'None';
    },
  },
  methods: {
    openTeamPicker() {
      EventBus.$emit('showTeamPicker', {});
    },
  },
};
</script>

<style scoped>
.app-sidebar__link {
  cursor: pointer;
}

.team-picker-button__badge {
  transition: transform 0.2s ease;
}

.app-sidebar__link:hover .team-picker-button__badge {
  transform: scale(1.08);
}
</style>
